module.exports = __webpack_public_path__ + "static/freeze-frame-a6bb2fb175b9b5f151b5ebb29b5650f3.png";